import React from 'react';
import { ShelfTypeFilterEnum } from '@soundxyz/utils/const';
import { CtaWrapper } from '@components/Profile/styles';
import { Button } from '@components/main-components/button/Button';
import { NoPlaylistsFound } from '@components/main-components/media/illustrations/NoPlaylistsFound';
import { MediaQuery } from '@context/mediaQuery';

export const OWNER_NO_PLAYLISTS_COPY = (
  <p>
    You don't have any playlists yet.
    <br />
    It's a bit quiet in here.
  </p>
);

export const NO_PLAYLIST_COPY = (
  <p>
    There are no playlists yet.
    <br />
    It's a bit quiet in here.
  </p>
);

export const OWNER_NO_LIKED_PLAYLISTS_COPY = (
  <p>
    You haven't liked any playlists yet.
    <br />
    It's a bit quiet in here.
  </p>
);

export const NO_LIKED_PLAYLISTS_COPY = <p>This user hasn't liked any playlists yet.</p>;

export const CREATE_NEW_PLAYLIST_COPY = <p>Sonically inspired?</p>;

export const newPlaylistCtaCopy = ({
  isOwner,
  type,
  hasPlaylists,
}: {
  isOwner: boolean;
  type: ShelfTypeFilterEnum;
  hasPlaylists?: boolean;
}) => {
  switch (type) {
    case ShelfTypeFilterEnum.LIKED:
      return isOwner ? OWNER_NO_LIKED_PLAYLISTS_COPY : NO_LIKED_PLAYLISTS_COPY;
    default:
      if (hasPlaylists && isOwner) {
        return CREATE_NEW_PLAYLIST_COPY;
      }
      return isOwner ? OWNER_NO_PLAYLISTS_COPY : NO_PLAYLIST_COPY;
  }
};

export const NewPlaylistCta = ({
  isOwner,
  type,
  hasPlaylists = false,
  card = false,
}: {
  isOwner: boolean;
  type: ShelfTypeFilterEnum;
  /** Does user have any playlists? */
  hasPlaylists?: boolean;
  /** If we want to render a card variant */
  card?: boolean;
}) => {
  const { tabletLandscape } = MediaQuery.useContainer();
  const isMini = !tabletLandscape;

  return (
    <CtaWrapper card={card}>
      <NoPlaylistsFound />
      {newPlaylistCtaCopy({ isOwner, type, hasPlaylists })}
      {isOwner && type !== ShelfTypeFilterEnum.LIKED && (
        <Button
          data-testid="new-playlist-cta"
          deprecatedCSS={{ marginTop: 24 }}
          variant="primary"
          label={isMini ? 'New playlist' : 'Create new playlist'}
          href="/playlist/new"
        />
      )}
    </CtaWrapper>
  );
};
